var _circle, _path, _circle2, _ellipse, _circle3, _ellipse2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "happy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_798",
    "data-name": "Ellipse 798",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#ffd93b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37763",
    "data-name": "Path 37763",
    d: "M110.073,80.073A30,30,0,0,1,56.72,98.907,30,30,0,0,0,98.907,56.72,29.968,29.968,0,0,1,110.073,80.073Z",
    transform: "translate(-50.073 -50.073)",
    fill: "#f4c534"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_799",
    "data-name": "Ellipse 799",
    cx: 4.708,
    cy: 4.708,
    r: 4.708,
    transform: "translate(36.328 21.729)",
    fill: "#3e4347"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_800",
    "data-name": "Ellipse 800",
    cx: 1.425,
    cy: 0.922,
    rx: 1.425,
    ry: 0.922,
    transform: "matrix(-0.914, -0.405, 0.405, -0.914, 43.3, 25.772)",
    fill: "#5a5f63"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_801",
    "data-name": "Ellipse 801",
    cx: 4.708,
    cy: 4.708,
    r: 4.708,
    transform: "translate(14.256 21.729)",
    fill: "#3e4347"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_802",
    "data-name": "Ellipse 802",
    cx: 1.425,
    cy: 0.922,
    rx: 1.425,
    ry: 0.922,
    transform: "matrix(-0.914, -0.405, 0.405, -0.914, 21.226, 25.772)",
    fill: "#5a5f63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37764",
    "data-name": "Path 37764",
    d: "M147.8,338.754a1.406,1.406,0,1,1,1.927-2.047,15.137,15.137,0,0,0,20.722,0,1.406,1.406,0,0,1,1.928,2.047A17.951,17.951,0,0,1,147.8,338.754Z",
    transform: "translate(-130.09 -296.911)",
    fill: "#3e4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.960bd1f6763b3b9ef2779e0072f2c0aa.svg";
export { ForwardRef as ReactComponent };